import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getFormError, emailPhoneUseridValidator } from '../util';
import { CommonService } from '../common.service';
declare var $: any;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contactform: FormGroup;
  requestError = '';
  requestMessage = '';
  data : {};
  getFormError = getFormError;
  visible = true;
  Location = null;
  constructor(private fb: FormBuilder,private cs: CommonService) { }

  ngOnInit() {
    this.contactform = this.fb.group({
      FirstName: ['', [Validators.required]],
      LastName: ['', [Validators.required]],
      Email: ['', [Validators.required, emailPhoneUseridValidator, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
      Phone: ['', [Validators.required]],
      Message: ['', [Validators.required]],
      Location: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_@./#&+,!$%^();:"'*=-]*$/)]],
    });

    this
  }

  handleCurrentLocationAddressChange(event) {
    var street_number = '';
    var route = '';

    this.Location = {};

    for (let address of event.address_components) {
      if (address.types.indexOf("locality") != -1) {
        this.Location.City = address.short_name
      } else if (address.types.indexOf("route") != -1) {
        route = address.short_name;
      } else if (address.types.indexOf("street_number") != -1) {
        street_number = address.short_name;
      }else if (address.types.indexOf("administrative_area_level_1") != -1) {
        this.Location.State = address.short_name;
      }else if (address.types.indexOf("administrative_area_level_2") != -1) {
        this.Location.County = address.short_name;
      } else if (address.types.indexOf('postal_code') != -1) {
        this.Location.Zip = address.long_name;
      } else if (address.types.indexOf('country') != -1) {
        this.Location.Country = address.short_name;
      }
    }
    if(this.Location.Country == null || this.Location.Country == undefined || this.Location.Country == '') {
      this.Location.City = '';
      return;
    }

    this.Location.Lat = event.geometry.location.lat();
    this.Location.Lng = event.geometry.location.lng();

    if(street_number != null && street_number.length > 0){
      this.Location.Street = street_number;
    }
    if(route != null && route.length > 0){
      if(this.Location.Street != null &&  this.Location.Street.length > 0){
        this.Location.Street += ' ';
      }
      this.Location.Street += route;
    }
    this.Location.Error = '';
  }

  contactsubmit() {
    this.requestError = '';
    this.requestMessage = '';
    if(this.Location == null || (this.Location != null && (this.Location.City == null || this.Location.City == ''))){
      this.Location = {};
      this.Location.Error = 'Please select an address from location auto complete';
      if (this.contactform.invalid) {
        this.contactform.markAllAsTouched();
      }
      return;
    }
    if (this.contactform.invalid) {
      this.contactform.markAllAsTouched();
      return;
    }
    let data = this.contactform.getRawValue();
    data.Location = this.Location;
    this.cs.request('/public/contact', 'post', data).then((res: any) => {
      if (res.Status == 200) {
        this.requestMessage = res.Message;
        this.visible = false;
      } else {
        this.requestError = res.Message;
      }
    }).catch((err) => {
    })
  }

}
